import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  progressInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',

    '& .eventProgress': {
      '& .progressBarTop': {
        '& .progressBarLabel': {
          display: 'flex',
          gap: '6px',

          '& b': {
            color: 'var(--text-primary)',
          },

          '@media screen and (min-width: 1441px)': {
            gap: '10px',
          },
        },
      },

      '& .progressBar': {
        border: 'none',
        backgroundColor: 'var(--primary-lighty)',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '20px',
    },
  },
}));

export default useStyles;
